export const CalendarEventFragment = gql`
  fragment CalendarEventFragment on CalendarEvent {
    id
    name
    deletedAt
    eventType
    hasExternalCalendarEvent
    details {
      ...CalendarEventDetailsFragment
    }
    proposal {
      ...CalendarEventProposalFragment
    }
    recordTaskInspectionAttempt {
      ...CalendarEventRecordTaskInspectionAttemptFragment
    }
  }

  fragment CalendarEventDetailsFragment on CalendarEventDetails {
    notes
    moment {
      ...CalendarEventMomentFragment
    }
    ownedByUser {
      ...UserDataFragment
    }
  }

  fragment CalendarEventProposalFragment on CalendarEventProposal {
    notes
    moment {
      ...CalendarEventMomentFragment
    }
    ownedByUser {
      ...UserDataFragment
    }
  }

  # This fragment exists to load inspection attempt events without self-referencing attempt data
  fragment CalendarEventSummaryFragment on CalendarEvent {
    id
    details {
      moment {
        ...CalendarEventMomentFragment
      }
    }
    proposal {
      moment {
        ...CalendarEventMomentFragment
      }
    }
  }

  fragment CalendarEventMomentFragment on CalendarEventMoment {
    ... on CalendarEventMomentDate {
      date
    }
    ... on CalendarEventMomentDateTime {
      endTime
      startTime
    }
  }

  fragment CalendarEventRecordTaskInspectionAttemptFragment on RecordTaskInspectionAttempt {
    ...RecordTaskInspectionAttemptFragment
    schedulingIntakeFormFieldGroup {
      id
      fields {
        ...FieldFragment
      }
    }
  }
`
